import React from 'react';
import { useAuthorization } from '~/hooks/auth';
import Loading from '~/shared/Loading';
import { Section } from '~/shared/Theme';
import ProfileMenuOptions from './components/ProfileMenuOptions';

const ProfileMenuScreen = () => {

    const { isLoadingAuth } = useAuthorization();

    if (isLoadingAuth) {
        return <Loading isLoading={isLoadingAuth}/>;
    }

    return (
        <Section>
            <ProfileMenuOptions />
        </Section>
    );
};


export default ProfileMenuScreen;
